import { getTransaction as getTransactionApi } from '@/api/transactions/me'
import { Blockchain } from '@/constants/blockchain'

export async function getBackendTransactionStatus({
  scId,
  txId,
  event,
  blockchain = Blockchain.Ethereum,
}: {
  scId: string
  txId: string
  event: string
  blockchain: Blockchain.Ethereum
}) {
  const result = await getTransactionApi({ scId, txId, event, blockchain })
  return { status: result.status }
}
